<template>
  <div class="admin-create-order pl-0 pr-0 pl-sm-2 pr-sm-2">
    <header-title title="Crear Pedido"></header-title>

    <Loader :dialog-loader="dialogLoader" message="Cargando..."></Loader>
    <br />
    <v-container fluid class="pl-0 pr-0">
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col cols="12" sm="6" md="6" lg="6">
            <v-select
              v-model="selectedQR"
              :items="activesQR"
              style="width: 200px"
              label="Selecciona mesa"
              @change="onChangeTable"
              :item-text="qr => tableQRLabel(qr.table)"
              item-value="table"
              dense
              outlined
              hide-details
              class="table-selctor"
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" lg="6" md="6" sm="6">
            <v-btn dark @click="refreshPage" class="filters">
              <v-icon dark> mdi-refresh </v-icon>
              &nbsp;Refrescar Carta
            </v-btn>
          </v-col>
        </v-row>

        <Products :isAdmin="true"></Products>

        <MiniCart :isAdmin="true" style="height: auto"></MiniCart>

        <v-row>
          <v-col align="center">
            <div class="my-2 mr-5 mt-5 pt-5">
              <v-btn
                dense
                outlined
                @click="disableBtn"
                type="button"
                :style="adminNavigationBackTheme"
                :disabled="disableCreateOrderBtn"
              >
                Crear pedido
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-form>
      <SharedItems
        ref="sharedItemModalRef"
        @submit="checkout"
        :isAdmin="true"
      ></SharedItems>
    </v-container>
  </div>
</template>

<script>
import Loader from "@/components/common/Loader";
import { firestoreTimestamp } from "@/firebaseConfig";
import firebaseMixin from "@/mixins/firebase/firebaseMixin";
import successMixin from "@/mixins/success/SuccessMixin";
import HeaderTitle from "@/components/admin/common/HeaderTitle";
import MiniCart from "@/components/public/cart/MiniCart";
import Products from "@/components/public/products/Products.vue";
import { saveOrder } from "@/collections/orders";
import {
  getOrderTotalByTableById,
  updateOrderTotalByTable,
  saveOrderTotalByTable
} from "@/collections/ordersTotalByTable";
import { saveOrderComment } from "@/collections/orderComments";
import { qrCollection } from "@/collections/qrs";
import SharedItems from "@/components/public/cart/SharedItems";

export default {
  name: "CreateOrder",
  components: { HeaderTitle, Loader, MiniCart, Products, SharedItems },
  mixins: [firebaseMixin, successMixin],
  data() {
    return {
      dialogLoader: false,
      panel: 0,
      orderCreated: false,
      selectedQR: "",
      qrCollection: [],
      total: 0,
      paymentType: "products",
      disableCreateOrderBtn: false
    };
  },
  created() {
    if (!this.settings) {
      this.getSettings();
    }
  },
  firestore() {
    return {
      qrCollection: qrCollection.where("active", "==", true).orderBy("table")
    };
  },
  mounted() {
    setTimeout(() => {
      this.$store.commit("setActivesQR", this.qrCollection);
    }, 1000);
    this.selectedQR = localStorage.getItem("adminTableQR")
      ? localStorage.getItem("adminTableQR")
      : "todas";
    this.selectedQR
      ? this.$router.push({
          path: "create-order",
          query: {
            qr: this.selectedQR !== "todas" ? this.selectedQR : "NO QR"
          }
        })
      : "";
  },
  computed: {
    activesQR() {
      let qr = [...this.qrCollection];
      qr = qr.sort((a, b) => {
        return a.table.localeCompare(b.table, undefined, {
          numeric: true,
          sensitivity: "base"
        });
      });
      return [{ id: "NO QR", table: "todas" }, ...qr];
    },
    userProfile() {
      return this.$store.state.userProfile;
    },
    paymentOn() {
      return firestoreTimestamp.fromDate(new Date());
    },
    cart() {
      return this.$store.state.admincart;
    }
  },
  methods: {
    refreshPage() {
      window.location.reload();
    },
    onChangeTable(value) {
      this.selectedQR = value;
      localStorage.setItem("adminTableQR", value);
      this.$store.state.adminTableQR = value;
      this.$router.push({
        path: "create-order",
        query: { qr: value !== "todas" ? value : "NO QR" }
      });
    },
    disableBtn() {
      this.disableCreateOrderBtn = true;
      this.createOrder();
    },
    async createOrder() {
      if (this.cart.length > 20) {
        this.showErrorMessage(this.$t("cart.theMaximumNumberOfProductAllowed"));
        return;
      }
      let hasMenuGroupProduct = this.cart.some(x => x.isMenuGroupProduct);
      let hasSharedItem = this.cart.find(x => x.canBeShared || false);
      setTimeout(async () => {
        if (hasSharedItem && !hasMenuGroupProduct) {
          this.$refs.sharedItemModalRef.openDialog();
        } else {
          await this.checkout();
        }
      }, 100);
    },
    async checkout() {
      try {
        if (this.cart.length > 0 && this.orderCreated === false) {
          this.dialogLoader = true;
          let time = firestoreTimestamp.fromDate(new Date());
          this.cart.forEach(item => {
            let id = this.uuidv4();
            saveOrder(id, this.buildOrder(item, time, id));
            this.total += item.price * item.quantity;
          });

          // save amount in orders_total_by_table collection
          let orderTotal = await getOrderTotalByTableById(this.selectedQR);
          console.log(orderTotal);
          if (orderTotal) {
            orderTotal.remaining += this.total;
            orderTotal.time = time;
            await updateOrderTotalByTable(this.selectedQR, orderTotal);
          } else {
            await saveOrderTotalByTable(this.selectedQR, {
              tableQR: this.selectedQR,
              remaining: this.total,
              time: time
            });
          }

          // save general comments in firebase
          let generalCommentText = localStorage.getItem(
            "admin-general-comment"
          );

          if (generalCommentText) {
            let generalComment = {
              time: time,
              email: this.$store.getters.getEmail(true),
              tableQR: this.selectedQR,
              comment: generalCommentText
            };
            await saveOrderComment(generalComment);
            localStorage.setItem("admin-general-comment", "");
          }

          this.showSuccessMessage("Pedido Realizado");

          // create order admin log
          this.setlogInfo(
            "create_order_admin",
            "Pedido creado",
            [...this.cart],
            this.$options.name
          );

          this.orderCreated = true;

          // clear everything from local storage
          this.$store.commit("removeAllAdminCart");

          this.dialogLoader = false;
          this.$router.push({
            name: "CreateOrderSuccess",
            query: {
              totalPrice: this.total
            }
          });
        }
      } catch (error) {
        this.setlogError(
          "save_order_comment/update/get_order_total_by_table",
          "Obtained error message in createOrder()",
          error.stack,
          this.$options.name
        );
        this.dialogLoader = false;
        this.showErrorMessage("Algo salió mal");
      } finally {
        this.disableCreateOrderBtn = false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.padTop {
  padding-top: 10px;
}
</style>
